<template>
  <div style="height: 100%">
    <v-card tile style="height: 100%" v-if="isRightUrl">
      <v-card-title class="pl-0">
        <v-icon color="cyan" class="mdi-rotate-90" large
          >mdi-window-minimize</v-icon
        >我的文件
        <!-- <v-spacer /> -->
        <v-btn color="primary" text class="ml-4" small v-one-click @click="init"
          >刷新</v-btn
        >
        <!-- <v-btn color="primary" small v-one-click @click="onDownload">下载</v-btn> -->
      </v-card-title>
      <v-card-text>
        <v-treeview
          item-key="path"
          :items="dataList"
          dense
          :load-children="listFile"
        >
          <template v-slot:label="{ item }">
            <span class="teal--text" v-if="item.dir">{{ item.name }}</span>
            <span v-else>
              <a @click="onDownload(item)">{{ item.name }}</a>
            </span>
            <code v-if="!item.dir" class="ml-1">{{
              Utility.kindFileSize(item.size)
            }}</code>
          </template>
          <template v-slot:prepend="{ item, open }">
            <v-icon color="teal" v-if="item.dir">{{
              open ? "mdi-folder-open" : "mdi-folder"
            }}</v-icon>
            <v-icon color="teal" v-else>{{ getFileIcon(item) }}</v-icon>
          </template>
        </v-treeview>
      </v-card-text>
    </v-card>
    <v-row v-else style="margin-top: 100px" justify="center">
      <v-col cols="auto" class="text-h3 orange--text">暂无数据</v-col>
    </v-row>
  </div>
</template>
<script>
import { userFileList, userFileSpeedKey } from "@/plugins/api";
export default {
  data() {
    return {
      dataList: [],
      urlQuery: {}, //url路由
    };
  },
  computed: {
    isRightUrl() {
      if (
        this.urlQuery.path &&
        this.urlQuery.projectNo &&
        this.urlQuery.endType &&
        this.urlQuery.endType === "ncc"
      ) {
        return true;
      } else {
        return false;
      }
    },
  },
  methods: {
    getUrlQuery() {
      this.urlQuery = this.$route.query;
    },
    init() {
      this.dataList = [];
      this.getUrlQuery();
      if (this.isRightUrl) this.listFile();
    },
    listFile(item) {
      if(!this.isRightUrl) return;
      if (!item) {
        userFileList({
          path: this.urlQuery.path,
          regex: `^${this.urlQuery.projectNo}.*`,
        }).then((res) => {
          let d = res.data || [];
          d.forEach((item) => {
            if (item.dir) item.children = [];
          });
          this.dataList = d;
        });
      } else {
        return userFileList({ path: item.path, regex: "[^_].*" }).then(
          (res) => {
            let d = res.data || [];
            d.forEach((item) => {
              if (item.dir) item.children = [];
            });
            item.children = d;
          }
        );
      }
    },
    getFileIcon(item) {
      let name = item.name;
      let parts = name.split(".");
      let type = parts[parts.length - 1].toLowerCase();
      return this.Utility.FILE_ICON[type] || this.Utility.FILE_ICON.none;
    },
    onDownload(item) {
      let dto = { path: item.path };
      userFileSpeedKey(dto).then((res) => {
        let d = res.data || "";
        let speedDownloadUrl =
          this.Utility.userApi + "/api/pub/file/stream/speed/" + d;
        window.open(speedDownloadUrl);
      });
    },
  },
  components: {},
  created() {
    this.init();
  },
};
</script>
